import { render, staticRenderFns } from "./RoomSelector.vue?vue&type=template&id=3247a422&scoped=true"
import script from "./RoomSelector.vue?vue&type=script&lang=js"
export * from "./RoomSelector.vue?vue&type=script&lang=js"
import style0 from "./RoomSelector.vue?vue&type=style&index=0&id=3247a422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247a422",
  null
  
)

export default component.exports